import { motion } from 'framer-motion';
import * as React from 'react';
import styled from 'styled-components';

const ButtonBase = styled(motion.button)`
  border: none;
  background-color: transparent;
  font-family: inherit;
  padding: 0;
  cursor: pointer;
  padding: 15px 20px;
  min-width: 163px;
  outline: none;
  transition: background-color 0.3s, box-shadow 0.3s;
  font-size: 16px;
  font-weight: 500;
  :disabled {
    background: ${(props) => props.theme.palette.background.white};
    border: 1px solid ${(props) => props.theme.palette.text.disabled};
    color: ${(props) => props.theme.palette.text.disabled};
    cursor: not-allowed;
  }
`;

export const Button = (props) => {
  return <ButtonBase whileHover={{ scale: 1.09 }} whileTap={{ scale: 0.99 }} {...props} />;
};

const PrimaryBase = styled(Button)`
  background: ${(props) => props.theme.palette.primary.main};
  color: ${(props) => props.theme.palette.text.white};
  &:hover {
    background: ${(props) => props.theme.palette.primary.dark};
  }
`;
const SecondaryBase = styled(Button)`
  background: ${(props) => props.theme.palette.background.white};
  color: ${(props) => props.theme.palette.primary.main};
  border: 1px solid ${(props) => props.theme.palette.background.border};
  &:hover {
    background: ${(props) => props.theme.palette.background.whiteBg800};
  }
`;

export const PrimaryButton = (props) => {
  return <PrimaryBase {...props} />;
};
export const SecondaryButton = (props) => {
  return <SecondaryBase {...props} />;
};
